import { AlkLogger } from '@alk/core';
import { ICommunicationService } from './communication.interface';
import { injectable } from 'inversify';
import { IStreamData } from '../../interfaces';
import { map } from 'rxjs/operators';
import { Observable, timer } from 'rxjs';

@injectable()
export class CommunicationMock implements ICommunicationService {

    subs: Array<number> = new Array<number>();

    delete(subId: number): void {
        const idx = this.subs.indexOf(subId);

        if (idx > -1) {
            this.subs.slice(idx, 1);
        }
    }

    subscriptionsList(): Array<number> {
        return this.subs;
    }

    dataObservable(type: number): Observable<IStreamData<Uint8Array>> {
        return timer(1000, 1000).pipe(
            map(communicationToken => {
                return { clientToken: type.toString(), communicationToken } as IStreamData<Uint8Array>;
            }));
    }
    create(msg: Uint8Array, type: number): number {
        AlkLogger.info(`[CommunicationMock#create] with message ${ msg } for type ${ type }`);
        return 1;
    }

    send(msg: Uint8Array, type: number): void {
        AlkLogger.info(`[CommunicationMock#send] with message ${ msg } for type ${ type }`);
    }

    start(): Promise<void> {
        AlkLogger.info('[CommunicationMock#start]');

        return Promise.resolve();
    }

    stop(): void {
        AlkLogger.info('[CommunicationMock#stop]');
    }

    generateRequestId(): number {
        AlkLogger.info('[CommunicationMock#generateRequestId]');

        return 404;
    }
}
